import React from 'react';
import styled from 'styled-components';
import { StaticImage } from 'gatsby-plugin-image';
import { Card } from '@/components/card';
import { VSpace } from '@/components/spacing';
import { Schedule } from '@/webapi/use-experience-api';
import { parseScheduledTime } from '@/utils/experience-utils';
import { breakpoints } from '@/components/responsive';

export function ScheduledChart({ schedule }: { schedule: Schedule }) {
  return (
    <>
      <VSpace className="only-desktop" value={3} />
      <VSpace className="only-mobile" value={1} />
      <DetailsCard>
        <Wrapper>
          <IconWrapper>
            <StaticImage
              src="clock.svg"
              alt="no_data"
              placeholder="none"
              loading="eager"
              formats={[`png`, `webp`]}
              height={70}
            />
          </IconWrapper>
          <ScheduledText>
            {`Experience scheduled ${parseScheduledTime(schedule)}, ${
              schedule?.timeZone?.label
            }`}
          </ScheduledText>
        </Wrapper>
      </DetailsCard>
    </>
  );
}

const Wrapper = styled.div`
  padding: 5rem 0;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 5rem 1fr;
  grid-gap: 2rem;
  ${breakpoints.down(`md`)} {
    padding: 2rem;
    grid-gap: 1rem;
  }
`;

const IconWrapper = styled.div`
  display: flex;
  margin: 0 0 8px 0;
  padding: 0;
  justify-content: center;
  align-items: center;
  ${breakpoints.down(`md`)} {
    .gatsby-image-wrapper {
      transform: scale(0.7);
    }
  }
`;

const ScheduledText = styled.p`
  color: #a6afb8;
  font-size: 2rem;
  font-family: 'JetBrains Mono', serif;
  max-width: 60rem;
  margin: 2rem auto 0;
  line-height: 1.5;
  span {
    font-size: 1.5rem;
    font-weight: 500;
  }
  font-weight: 700;
  text-align: center;

  ${breakpoints.down(`md`)} {
    font-size: 1.4rem;
    font-weight: 600;
  }
`;

const DetailsCard = styled(Card)`
  && {
    cursor: default;
    display: grid;
    grid-row-gap: 2.5rem;
    padding: 2.5rem;
    border-radius: 2rem;

    ${breakpoints.down(`md`)} {
      width: 90%;
      margin: 0 auto;
    }
  }
`;
